// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 全局样式重置 */
body,
html {
    margin: 0;
    padding: 0;
    height: 100%;
    font-family: Arial, sans-serif;
}

/* 网格容器 */
.container {
    display: grid;
    grid-template-rows: auto 1fr;
    /* 上部高度自适应，下部占满剩余空间 */
    height: 90vh;
    /* 容器占满整个视口高度 */
}

/* 编辑器样式 */
.editor {
    background-color: #fff;
    overflow-y: auto;
}

.editor textarea {
    width: 100%;
    height: 100%;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 1px;
    resize: none;
}

/* 调整查找窗口的宽度和高度 */
.monaco-editor .find-widget {
    width: 400px !important; /* 设置查找窗口的宽度 */
    height: auto; /* 根据内容自动调整高度 */
    max-height: 200px; /* 如果想限制最大高度，可以这样设置 */
}

/* 调整查找输入框的宽度 */
.monaco-editor .find-widget .monaco-inputbox {
    width: 100% !important; /* 输入框占据整个宽度 */
}

/* 调整替换输入框的宽度 */
.monaco-editor .find-widget .replace-input {
    width: 100% !important; /* 替换框也占据整个宽度 */
}

/* 调整查找替换的按钮大小 */
.monaco-editor .find-widget .button {
    height: 30px !important; /* 设置按钮高度 */
    width: auto !important;  /* 根据内容自动调整按钮宽度 */
}`, "",{"version":3,"sources":["webpack://./src/pages/corpus-editor.css"],"names":[],"mappings":"AAAA,WAAW;AACX;;IAEI,SAAS;IACT,UAAU;IACV,YAAY;IACZ,8BAA8B;AAClC;;AAEA,SAAS;AACT;IACI,aAAa;IACb,4BAA4B;IAC5B,qBAAqB;IACrB,YAAY;IACZ,eAAe;AACnB;;AAEA,UAAU;AACV;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;;AAEA,iBAAiB;AACjB;IACI,uBAAuB,EAAE,cAAc;IACvC,YAAY,EAAE,eAAe;IAC7B,iBAAiB,EAAE,qBAAqB;AAC5C;;AAEA,eAAe;AACf;IACI,sBAAsB,EAAE,cAAc;AAC1C;;AAEA,eAAe;AACf;IACI,sBAAsB,EAAE,eAAe;AAC3C;;AAEA,gBAAgB;AAChB;IACI,uBAAuB,EAAE,WAAW;IACpC,sBAAsB,GAAG,iBAAiB;AAC9C","sourcesContent":["/* 全局样式重置 */\nbody,\nhtml {\n    margin: 0;\n    padding: 0;\n    height: 100%;\n    font-family: Arial, sans-serif;\n}\n\n/* 网格容器 */\n.container {\n    display: grid;\n    grid-template-rows: auto 1fr;\n    /* 上部高度自适应，下部占满剩余空间 */\n    height: 90vh;\n    /* 容器占满整个视口高度 */\n}\n\n/* 编辑器样式 */\n.editor {\n    background-color: #fff;\n    overflow-y: auto;\n}\n\n.editor textarea {\n    width: 100%;\n    height: 100%;\n    font-size: 16px;\n    border: 1px solid #ccc;\n    border-radius: 1px;\n    resize: none;\n}\n\n/* 调整查找窗口的宽度和高度 */\n.monaco-editor .find-widget {\n    width: 400px !important; /* 设置查找窗口的宽度 */\n    height: auto; /* 根据内容自动调整高度 */\n    max-height: 200px; /* 如果想限制最大高度，可以这样设置 */\n}\n\n/* 调整查找输入框的宽度 */\n.monaco-editor .find-widget .monaco-inputbox {\n    width: 100% !important; /* 输入框占据整个宽度 */\n}\n\n/* 调整替换输入框的宽度 */\n.monaco-editor .find-widget .replace-input {\n    width: 100% !important; /* 替换框也占据整个宽度 */\n}\n\n/* 调整查找替换的按钮大小 */\n.monaco-editor .find-widget .button {\n    height: 30px !important; /* 设置按钮高度 */\n    width: auto !important;  /* 根据内容自动调整按钮宽度 */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
